import { AddOn, AddOnGroup } from '@buy-viasat/types/build/bv';

export enum ThunkActions {
  trackEvent = 'trackEvent',
}

export enum DataLayerEventType {
  ADDON_SELECTED = 'addonSelected',
}

export type GetAddOnsPayload = {
  addOns: AddOn[];
  addOnGroup: AddOnGroup;
};
export type AddonsState = {
  availableAddons: GetAddOnsPayload | null;
  isAddonsLoading: boolean;
  loadingAddonId: string | null;
  isAddonsError: boolean;
  addonIdToRemove: string | null;
  addonIdToUpsert: string | null;
};

export type AddOnPrices = {
  id: string;
  addOnPrice: number;
  addOnPromo: number;
};

export const initialAddonsState: AddonsState = {
  availableAddons: null,
  isAddonsLoading: false,
  loadingAddonId: null,
  isAddonsError: false,
  addonIdToRemove: null,
  addonIdToUpsert: null,
};

